import React from "react";
import PropTypes from "prop-types";
import {useValue} from "@morningtrain/react-resources";
import useWillConstrain from "../hooks/use-will-constrain";

function ModelValueFilter({name, modelKey}) {

    const value = useValue(modelKey);

    useWillConstrain(name, value);

    return null;
}

ModelValueFilter.propTypes = {
    name: PropTypes.string.isRequired,
    modelKey: PropTypes.string.isRequired,
};

export default ModelValueFilter;
